/**
 * List all possible commands the system is capable of processing.
 */
export enum ServiceableAddressName {
  e164Phone = 'e164Phone',
}

export type ServiceableAddressNameType = keyof typeof ServiceableAddressName;
